<script>
import { matchCentreComment } from '../../../mixins/matchCentreComment';
import { matchCentreEditFixture } from '../../../mixins/matchCentreEditFixture';
import datePicker from 'vue-bootstrap-datetimepicker';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';

export default {
    data() {
        return {
            tab: 'score',
            disableOnSubmit: false,
            datePickerOptions: {
                format: 'MM/DD/YYYY',
                useCurrent: true,
            },
            matchComments: null,
            data: null,
            errorMessage: null,
            live_score: null,
            show_innings: 'home',
            home: 'one',
            away: 'two',
            message: null,
            descriptionBtn: false,
            interruptionBtn: false,
        }
    },
    mixins: [matchCentreComment, matchCentreEditFixture],

    props: [
        'commentsUrl', 'fixture', 'addCommentUrl', 'user', 'updateNameUrl',
        'forceUpdateUrl', 'updateCommentUrl', 'muteCommentUrl', 'fixtureUpdateUrl'
    ],
    mounted() {
        if (this.user) {
            if(this.user.first_name && this.user.last_name) {
                this.step = 3;
            } else {
                this.step = 2;
            }
        }

        this.getUpdates();
        this.getLiveScoreData();

        var self = this;
        setInterval(function(){
            // self.getUpdates();
            // self.getLiveScoreData();
        }, 60000);
    },
    components: {
        'date-picker': datePicker,
    },

    computed: {
        liveScoringEnabled: function () {
            if(this.fixture.live_score_id) {
                return false;
            } else {
                return true;
            }
        },
        liveStreamEnabled: function () {
            if(this.fixture.live_stream_embed) {
                return false;
            } else {
                return true;
            }
        },
        homeTeamWinLose : function() {
            return {
                win : this.winLose('win', this.fixture.team_home_title),
                lose: this.winLose('lose', this.fixture.team_home_title),
            }
        },
        awayTeamWinLose : function() {
            return {
                win : this.winLose('win', this.fixture.team_away_title),
                lose: this.winLose('lose', this.fixture.team_away_title),
            }
        },
        homeExtrasScore : function() {
            var total = 0;
            total += (!isNaN(this.live_score.matchinfo[this.home + '_no_balls']) ? parseInt(this.live_score.matchinfo[this.home + '_no_balls']) : 0);
            total += (!isNaN(this.live_score.matchinfo[this.home + '_wides']) ? parseInt(this.live_score.matchinfo[this.home + '_wides']) : 0);
            total += (!isNaN(this.live_score.matchinfo[this.home + '_byes']) ? parseInt(this.live_score.matchinfo[this.home + '_byes']) : 0);
            total += (!isNaN(this.live_score.matchinfo[this.home + '_lbyes']) ? parseInt(this.live_score.matchinfo[this.home + '_lbyes']) : 0);
            return total;
        },
        awayExtrasScore : function() {
            var total = 0;
            total += (!isNaN(this.live_score.matchinfo[this.away + '_no_balls']) ? parseInt(this.live_score.matchinfo[this.away + '_no_balls']) : 0);
            total += (!isNaN(this.live_score.matchinfo[this.away + '_wides']) ? parseInt(this.live_score.matchinfo[this.away + '_wides']) : 0);
            total += (!isNaN(this.live_score.matchinfo[this.away + '_byes']) ? parseInt(this.live_score.matchinfo[this.away + '_byes']) : 0);
            total += (!isNaN(this.live_score.matchinfo[this.away + '_lbyes']) ? parseInt(this.live_score.matchinfo[this.away + '_lbyes']) : 0);
            return total;
        },
        fixtureModalData : function() {
            // tidy up date before passing to modal
            var fixture = this.fixture;
            fixture.venue_id = this.fixture.venue.hashid;
            fixture.start_date = this.fixture.start_date_match_centre;
            return fixture;
        },
        oversAway : function() {
            if (!this.live_score)
                return null;

            var array = this.convertObjectToArray(this.live_score['ballbyball'][this.away]);
            return array.reverse();
        },
        teamWonToss : function() {
            if (!this.live_score)
                return null;

            return this.live_score.matchinfo.toss_won_team_name_flag;
        },        
    },
    methods: {

        getUpdates() {
            var self = this
            var url = this.commentsUrl + '/storage/match-centre/fixtures/' + this.fixture.hashid + '/updates.json'
            $.getJSON(url, function(data) {
                self.matchComments = data;
            });
        },
        getLiveScoreData() {
            if (this.fixture.live_score_id == null) {
                return;
            }
            var self = this
            var url = this.commentsUrl + '/storage/match-centre/fixtures/' + this.fixture.hashid + '/livescoring.json'
            $.getJSON(url, (data) => {
                self.live_score = data;
                self.cleanBatterOutData();
                self.cleanBallByBall();
            })
            .done((data) => {
                self.home = self.stringSimilarity(self.fixture.team_home_title.toLowerCase(), self.live_score['matchinfo']['one'].toLowerCase()) > 70 ? 'one' : 'two';
                self.away = self.stringSimilarity(self.fixture.team_away_title.toLowerCase(), self.live_score['matchinfo']['two'].toLowerCase()) > 70 ? 'two' : 'one';

                self.show_innings = this.live_score.current.battingTeam == self.home ? 'home' : 'away';

            })
            .fail(function(jqXHR, textStatus, errorThrown) {
            });
        },

        getBallClass(ball) {
            if (ball === 'W' || ball === 'w') {
                return 'wicket';
            } else if (ball == 4) {
                return 'fours';
            } else if (ball == 6) {
                return 'sixes';
            } else {
                return '';
            }
        },


        winLose(type, team)
        {
            if (!this.fixture.team_win_title
                || !(this.fixture.team_home_title == this.fixture.team_win_title
                        || this.fixture.team_away_title == this.fixture.team_win_title)) {
                return false;
            }

            if (team == this.fixture.team_win_title && type == 'win') {
                return true;
            }

            if (team != this.fixture.team_win_title && type == 'lose') {
                return true;
            }

            return false;
        },
        getFixtures() {
        },
        forceLiveScoreUpdate() {
            this.disableOnSubmit = true;
            var self = this;
            axios
                .get(self.forceUpdateUrl, {} )
                .then(response => {
                    self.disableOnSubmit = false;
                    self.getLiveScoreData();
                })
                .catch(error => {
                    console.log(error);
                    self.disableOnSubmit = false;
                });

        },
        cleanBatterOutData() {
            for (const key in this.live_score['players'][this.home + '_batsmen']) {
                if (this.live_score['players'][this.home + '_batsmen'].hasOwnProperty(key)) {
                    const element = this.live_score['players'][this.home + '_batsmen'][key];
                    if (element['runs'] === 0 && element['balls'] === 0 && element['fours'] === 0 && element['sixes'] === 0 && element['out_message'] === 'not out') {
                        element['out_message'] = '';
                    }
                    element['out_message'] = element['out_message'].replace('&#8224;', '');
                }
            }
            for (const key in this.live_score['players'][this.away + '_batsmen']) {
                if (this.live_score['players'][this.away + '_batsmen'].hasOwnProperty(key)) {
                    const element = this.live_score['players'][this.away + '_batsmen'][key];
                    if (element['runs'] === 0 && element['balls'] === 0 && element['fours'] === 0 && element['sixes'] === 0 && element['out_message'] === 'not out') {
                        element['out_message'] = '';
                    }
                    element['out_message'] = element['out_message'].replace('&#8224;', '');
                }
            }
        },
        stringSimilarity(a,b) {
            var lengthA = a.length;
            var lengthB = b.length;
            var equivalency = 0;
            var minLength = (a.length > b.length) ? b.length : a.length;
            var maxLength = (a.length < b.length) ? b.length : a.length;
            for(var i = 0; i < minLength; i++) {
                if(a[i] == b[i]) {
                    equivalency++;
                }
            }


            var weight = equivalency / maxLength;

            return (weight * 100);
        },
        cleanBallByBall() {
            if (!Array.isArray(this.live_score.ballbyball.one)) {
                this.live_score.ballbyball.one = this.convertObjectToArray(this.live_score.ballbyball.one).reverse();
            }
            if (!Array.isArray(this.live_score.ballbyball.two)) {
                this.live_score.ballbyball.two = this.convertObjectToArray(this.live_score.ballbyball.two).reverse();
            }
        },
        convertObjectToArray(object) {
            var array = [];
            for (const key in object) {
                if (object.hasOwnProperty(key)) {
                    const element = object[key];
                    array[key] = element;
                }
            }
            return array;
        },
        toggleUpdateDescription(type) {
            if (type == 'update') {
                this.descriptionBtn = false;
                this.interruptionBtn = !this.interruptionBtn;
            }
            
            if (type == 'description') {
                this.descriptionBtn = !this.descriptionBtn;
                this.interruptionBtn = false;                
            }
        },
        wonToss(team) {
            if (team == this.teamWonToss) {
                return true;
            }

            return false;
        }
    }
}
</script>
